import React, { ReactNode } from 'react';
import { SidebarProvider } from '@shared/providers/SidebarContext';
import { AppScrollTop } from '@components/atoms';

interface ConsoleTemplateProps {
  header: ReactNode;
  topBar?: ReactNode;
  sidebar: ReactNode;
  footer: ReactNode;
  children: ReactNode;
  sidebarOpen: boolean;
}

/**
 * Console Template
 *
 * Standard layout for Dashboard/Console pages with:
 * - Fixed Header
 * - Top Bar (breadcrumb and links)
 * - Collapsible Sidebar
 * - Scrollable Main Content
 * - Footer
 */
export const ConsoleTemplate: React.FC<ConsoleTemplateProps> = ({
  header,
  topBar,
  sidebar,
  footer,
  children,
  sidebarOpen,
}) => {
  return (
    <SidebarProvider sidebarOpen={sidebarOpen}>
      <AppScrollTop />
      <div className="flex flex-col min-h-screen bg-gray-50">
        {/* Header */}
        {header}

        {/* Top Bar */}
        {topBar}

        {/* Layout with Sidebar */}
        <div className="flex flex-1">
          {/* Sidebar */}
          {sidebar}

          {/* Main Content */}
          <main
            className={`flex-1 min-w-0 p-6 mb-[64px] transition-all duration-300 ${sidebarOpen ? 'ml-60' : ''}`}
          >
            {children}
          </main>
        </div>

        {/* Footer */}
        {footer}
      </div>
    </SidebarProvider>
  );
};
